import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavigationBarHome from "../components/navigation-bar-home";
import FAQPersonal from "../components/faq-personal";
import ContactFormLight from "../components/contact-form-light";
import Footer from "../components/footer";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>
          CashOver Pay | Digital Payment Solutions for You & Your Business |
          Lebanon
        </title>
        <meta
          name="description"
          content="CashOver is an all‑in‑one digital wallet for personal, merchant and business users | Send, receive, pay, deposit or withdraw money securely, anytime, anywhere."
        />
        <meta
          property="og:title"
          content="CashOver Pay | Digital Payment Solutions for You & Your Business | Lebanon"
        />
        <meta
          property="og:description"
          content="CashOver is an all‑in‑one digital wallet for personal, merchant and business users | Send, receive, pay, deposit or withdraw money securely, anytime, anywhere."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/hero.webp`}
        />
      </Helmet>
      <NavigationBarHome
        text={
          <Fragment>
            <span className="home-text100">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text101">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-homeroot-class-name"
      ></NavigationBarHome>
      <header id="Personal" className="home-column10">
        <div className="home-dummy"></div>
        <img alt="cashover" src="/hero.webp" className="home-image10" />
        <div className="home-row10">
          <div className="home-column11">
            <h1 className="home-title1">
              <span>
                CHANGE THE WAY YOU
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text103">MONEY</span>
            </h1>
            <h2 className="home-subtitle1">
              Whether you&apos;re paying a friend, running a store, or managing
              businesses — CashOver brings seamless financial tools to your
              fingertips.
            </h2>
            <div className="home-stores">
              <a
               href={process.env.REACT_APP_PERSONAL_ANDROID_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="home-link1"
              >
                <img
                  alt="image"
                  src="/play-badge.webp"
                  className="home-image11"
                />
              </a>
              <a
               href={process.env.REACT_APP_PERSONAL_IOS_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="home-link2"
              >
                <img
                  alt="image"
                  src="/apple-badge.webp"
                  className="home-image12"
                />
              </a>
            </div>
          </div>
          <img
            id="Personal"
            alt="image"
            src="/hero.webp"
            className="home-phone-image"
          />
        </div>
        <div id="Services" className="home-row11">
          <svg viewBox="0 0 1024 1024" className="home-icon10">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
          <span className="home-text104">Scroll Down to Learn More</span>
          <svg viewBox="0 0 1024 1024" className="home-icon12">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
        </div>
      </header>
      <main id="transactions" className="home-column12">
        <div className="home-row12">
          <div className="home-column13">
            <div className="home-column14">
              <img
                alt="cashover cashtag qrcode"
                src="/cashtag.webp"
                className="home-image13"
              />
              <div className="home-column15">
                <h2 className="home-text105">
                  <span className="home-text106">Send or Receive</span>
                  <span> — As Easy as Messaging</span>
                </h2>
                <h3 className="home-text108">
                  Your digital wallet for real life. Send money, receive
                  payments, and manage your balance across currencies — all from
                  one app.
                </h3>
                <span className="home-text109">
                  <span>Your </span>
                  <span className="home-text111">Cashtag</span>
                  <span>, Your Identity</span>
                </span>
                <span className="home-text113">
                  Share your wallet with ease — let others pay or find you
                  instantly using your Cashtag or QR code.
                </span>
              </div>
            </div>
          </div>
          <div className="home-column16">
            <img
              alt="send money cashover"
              src="/send.webp"
              loading="lazy"
              className="home-image14"
            />
            <div className="home-container11">
              <h2 className="home-text114">
                <span>
                  Your
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
                <span className="home-text116">Cashtag</span>
                <span>, Your Identity</span>
              </h2>
              <h3 className="home-text118">
                Share your wallet with ease — let others pay or find you
                instantly using your Cashtag or QR code.
              </h3>
              <span className="home-text119">
                <span className="home-text120">Send or Receive</span>
                <span> — As Easy as Messaging</span>
              </span>
              <span className="home-text122">
                Your digital wallet for real life. Send money, receive payments,
                and manage your balance across currencies — all from one app.
              </span>
            </div>
          </div>
        </div>
      </main>
      <main id="payment" className="home-column17">
        <div className="home-column18">
          <h2 className="home-text123">
            <span>
              Pay Your Way — The
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <span className="home-text125">Smarter</span>
            <span> Way</span>
          </h2>
          <h3 className="home-text127">
            <span>
              Scan and pay anywhere — from your favorite stores to your favorite
              sites, right from your wallet.
            </span>
            <br></br>
          </h3>
        </div>
        <div className="home-container12">
          <div className="home-container13">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              className="home-icon14"
            >
              <path
                d="M13 20.039V18.23h1.808v1.807zm-1.808-1.808v-4.423H13v4.423zm7.039-3.385V12h1.807v2.846zM16.423 12v-1.808h1.808V12zM5.769 13.808V12h1.808v1.808zM3.962 12v-1.808h1.807V12zM12 5.77V3.961h1.808v1.807zM4.846 8.5H8.5V4.846H4.846zm-.884.077V4.769q0-.343.232-.575t.575-.232h3.808q.343 0 .576.232q.231.232.231.575v3.808q0 .343-.232.576t-.575.232H4.769q-.343 0-.575-.232q-.232-.233-.232-.576m.884 10.577h3.808V15.5H4.846zm-.884.077v-3.808q0-.343.232-.575q.232-.233.575-.233h3.962q.343 0 .575.233q.233.232.233.575v3.808q0 .343-.233.575t-.575.233H4.769q-.343 0-.575-.233t-.232-.575M15.5 8.5h3.654V4.846H15.5zm-.885.077V4.769q0-.343.233-.575q.232-.232.575-.232h3.808q.343 0 .575.232t.233.575v3.808q0 .343-.233.576q-.232.232-.575.232h-3.808q-.343 0-.575-.232q-.233-.233-.233-.576m1.808 11.462v-3.385h-1.807v-1.808h3.615v3.385h1.807v1.807zM13 13.808V12h3.423v1.808zm-3.616 0V12H7.578v-1.808H13V12h-1.808v1.808zm.808-4.424V5.77H12v1.808h1.808v1.808zM6.038 7.308v-1.27h1.27v1.27zm.135 10.519v-1.27h1.27v1.27zm10.52-10.52V6.039h1.268v1.27z"
                fill="currentColor"
              ></path>
            </svg>
            <h2 className="home-text130">Scan to Pay</h2>
          </div>
          <div className="home-container14">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              className="home-icon16"
            >
              <g
                fill="none"
                color="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M13 6a4 4 0 0 0-8 0"></path>
                <path d="M10.318 8.921V6.364a1.364 1.364 0 0 0-2.727 0v7.892L6.118 12.8a1.547 1.547 0 0 0-2.282.125a1.5 1.5 0 0 0-.03 1.854l2.732 3.595c.62.816.93 1.224 1.302 1.541c.57.484 1.25.82 1.984.98c.48.104.997.104 2.03.104c1.97 0 2.955 0 3.739-.297a4.5 4.5 0 0 0 2.606-2.573c.301-.774.301-1.747.301-3.691v-2.213a1.8 1.8 0 0 0-1.52-1.765l-.31-.05a.766.766 0 0 0-.897.747M10.318 8.92l.525-.258c.253-.125.535-.205.81-.14a1.796 1.796 0 0 1 1.393 1.74M10.318 8.92v2.237m2.728-.895v.895m0-.895c0-.494.407-.895.909-.895c1.004 0 1.818.802 1.818 1.79m0 0v.895"></path>
              </g>
            </svg>
            <h2 className="home-text131">Single Tap</h2>
          </div>
          <div className="home-container15">
            <svg
              width="20"
              height="20"
              viewBox="0 0 256 256"
              className="home-icon20"
            >
              <path
                d="M128 88a40 40 0 1 0 40 40a40 40 0 0 0-40-40m0 64a24 24 0 1 1 24-24a24 24 0 0 1-24 24m112-96H16a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h224a8 8 0 0 0 8-8V64a8 8 0 0 0-8-8m-46.35 128H62.35A56.78 56.78 0 0 0 24 145.65v-35.3A56.78 56.78 0 0 0 62.35 72h131.3A56.78 56.78 0 0 0 232 110.35v35.3A56.78 56.78 0 0 0 193.65 184M232 93.37A40.8 40.8 0 0 1 210.63 72H232ZM45.37 72A40.8 40.8 0 0 1 24 93.37V72ZM24 162.63A40.8 40.8 0 0 1 45.37 184H24ZM210.63 184A40.8 40.8 0 0 1 232 162.63V184Z"
                fill="currentColor"
              ></path>
            </svg>
            <h2 className="home-text132">No Fees</h2>
          </div>
          <div className="home-container16">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              className="home-icon22"
            >
              <path
                d="M4 14L14 3v7h6L10 21v-7z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            <h2 className="home-text133">Faster Than Ever</h2>
          </div>
        </div>
      </main>
      <header id="split bill" className="home-column19">
        <div className="home-row13"></div>
        <div className="home-column20">
          <h2 className="home-text134">
            <span className="home-text135">Split</span>
            <span> the Cost — Not the Fun</span>
          </h2>
          <h3 className="home-text137">
            <span>
              Easily divide bills with friends and pay your part in seconds — no
              math, no hassle.
            </span>
            <br></br>
          </h3>
        </div>
        <img alt="image" src="/split%20bill.webp" className="home-image15" />
      </header>
      <main id="crypto" className="home-column21">
        <div className="home-row14">
          <div className="home-column22">
            <h2 className="home-text140">
              <span>
                Step Into
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text142">Crypto</span>
              <span> — Effortlessly</span>
            </h2>
            <h3 className="home-text144">
              <span>
                Buy, sell, and send crypto in seconds — no experience needed.
              </span>
              <br></br>
            </h3>
          </div>
        </div>
        <div className="home-row15">
          <img alt="image" src="/buy%20crypto.webp" className="home-image16" />
          <div className="home-container17">
            <div className="home-container18">
              <div className="home-container19">
                <div className="home-container20">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon24"
                  >
                    <path
                      d="M3.01 10.72a4.985 4.985 0 0 0 4.07 5.18l-.79-.79A.996.996 0 1 1 7.7 13.7l2.59 2.59c.39.39.39 1.02 0 1.41l-2.58 2.6a.996.996 0 1 1-1.41-1.41l.88-.88v-.06a6.995 6.995 0 0 1-6.15-7.47C1.29 6.78 4.55 4 8.26 4H10c.55 0 1 .45 1 1s-.45 1-1 1H8.22c-2.7 0-5.07 2.04-5.21 4.72M15 11h5c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2m5-2h-5V6h5zm0 11h-5c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <span className="home-text147">
                  Move Your Tokens Wherever You Want
                </span>
              </div>
              <div className="home-container21">
                <div className="home-container22">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 256 256"
                    className="home-icon26"
                  >
                    <path
                      d="M128 88a40 40 0 1 0 40 40a40 40 0 0 0-40-40m0 64a24 24 0 1 1 24-24a24 24 0 0 1-24 24m112-96H16a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h224a8 8 0 0 0 8-8V64a8 8 0 0 0-8-8m-46.35 128H62.35A56.78 56.78 0 0 0 24 145.65v-35.3A56.78 56.78 0 0 0 62.35 72h131.3A56.78 56.78 0 0 0 232 110.35v35.3A56.78 56.78 0 0 0 193.65 184M232 93.37A40.8 40.8 0 0 1 210.63 72H232ZM45.37 72A40.8 40.8 0 0 1 24 93.37V72ZM24 162.63A40.8 40.8 0 0 1 45.37 184H24ZM210.63 184A40.8 40.8 0 0 1 232 162.63V184Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <span className="home-text148">Fees From 0%</span>
              </div>
              <div className="home-container23">
                <div className="home-container24">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 256 256"
                    className="home-icon28"
                  >
                    <g fill="currentColor">
                      <path
                        d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96"
                        opacity=".2"
                      ></path>
                      <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88a88.1 88.1 0 0 1-88 88M97.07 100.26a59.33 59.33 0 0 1 0 55.48a8 8 0 1 1-14.14-7.48a42.79 42.79 0 0 0 0-40.52a8 8 0 0 1 14.14-7.48m56-32a126.67 126.67 0 0 1 0 119.54a8 8 0 0 1-14.07-7.57a110.62 110.62 0 0 0 0-104.46a8 8 0 0 1 14.12-7.54Zm-28 16a93 93 0 0 1 0 87.52a8 8 0 1 1-14.12-7.52a77 77 0 0 0 0-72.48a8 8 0 1 1 14.12-7.52"></path>
                    </g>
                  </svg>
                </div>
                <span className="home-text149">Pay With Crypto Anywhere</span>
              </div>
              <div className="home-container25">
                <div className="home-container26">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon32"
                  >
                    <path
                      d="M9 12.5L6.5 15L9 17.5l2.5-2.5zm6-10a6.5 6.5 0 0 0-6.482 6.018a6.5 6.5 0 1 0 6.964 6.964A6.5 6.5 0 0 0 15 2.5m.323 10.989a6.51 6.51 0 0 0-4.812-4.812a4.5 4.5 0 1 1 4.812 4.812M13.5 15a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M3 7a4 4 0 0 1 4-4h1.5v2H7a2 2 0 0 0-2 2v1.5H3zm16 10v-1.5h2V17a4 4 0 0 1-4 4h-1.5v-2H17a2 2 0 0 0 2-2"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <span className="home-text150">
                  <span>Swap Tokens Anytime. Buy or Sell in Seconds</span>
                  <br></br>
                </span>
              </div>
            </div>
            <img
              alt="image"
              src="/crypto%20dashboard.webp"
              className="home-image17"
            />
          </div>
        </div>
      </main>
      <main className="home-column23">
        <div className="home-container27">
          <div className="home-container28">
            <h3 className="home-text153">
              <span>For Merchants — </span>
              <span>
                Get Paid,
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text156">Anywhere.</span>
            </h3>
            <h3 className="home-text157">
              Accept payments in-store or online using QR codes. Manage your
              orders, view real-time sales, and settle instantly.
            </h3>
            <div className="home-container29">
              <div className="home-container30">
                <div className="home-container31">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon34"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
                      <path
                        d="M18 2a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3h-3v-6a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3v6H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm-6 12a1 1 0 0 1 .993.883L13 15v6h-3v-6a1 1 0 0 1 .883-.993L11 14zm6-10H5a1 1 0 0 0-.993.883L4 5v1a2 2 0 0 0 3.94.49l.032-.155a1 1 0 0 1 .898-.831L9 5.5a1 1 0 0 1 .993.883L10 6.5a1.5 1.5 0 0 0 2.993.144L13 6.5a1 1 0 0 1 .883-.993l.135-.007a1 1 0 0 1 .984.723l.026.112a2 2 0 0 0 3.967-.186L19 6V5a1 1 0 0 0-.883-.993z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="home-container32">
                  <span className="home-text158">
                    Get started in under a minute
                  </span>
                  <span className="home-text159">
                    <span>
                      Create your merchant account, add your store, and start
                      accepting payments instantly. Create menu to take orders
                      easily.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container33">
                <div className="home-container34">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 1024 1024"
                    className="home-icon38"
                  >
                    <path
                      d="M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="home-container35">
                  <span className="home-text162">
                    Access your business from anywhere
                  </span>
                  <span className="home-text163">
                    <span>
                      Manage your store on mobile, tablet, or desktop—CashOver
                      Merchant works wherever you do.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container36">
                <div className="home-container37">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon40"
                  >
                    <path
                      d="M5 21q-.825 0-1.412-.587T3 19V6.5q0-.35.113-.663t.337-.587l1.4-1.7q.225-.275.513-.413T6 3h12q.35 0 .638.138t.512.412l1.4 1.7q.225.275.338.588T21 6.5V19q0 .825-.587 1.413T19 21zm.4-15h13.2l-.85-1H6.25zm9.15 11.05l3.55-3.55l-3.55-3.55l-1.45 1.45l2.1 2.1l-2.1 2.1zm-5.05 0l1.45-1.45l-2.1-2.1l2.1-2.1L9.5 9.95L5.95 13.5z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="home-container38">
                  <span className="home-text166">
                    {" "}
                    CashOver SDK Integration
                  </span>
                  <span className="home-text167">
                    <span>
                      Add payments to your website, app or project — in minutes!
                      <span
                        dangerouslySetInnerHTML={{
                          __html: " ",
                        }}
                      />
                    </span>
                    <a
                      href={process.env.REACT_APP_FEES_URL}
                      target="_blank"
                      rel="noreferrer noopener"
                      className="home-link3"
                    >
                      Learn more.
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <img alt="image"  src="/merchant%20hero.webp" className="home-image18" />
            <div className="home-container39">
              <Link
                to="/merchant"
                id="Get started with cashover merchant"
                name="CashOver Merhant"
                className="home-navlink1 button"
              >
                Get Started
              </Link>
              <Link
                to="/merchant"
                id="Get started with cashover merchant"
                name="CashOver Merhant"
                className="home-navlink2 thq-button-outline-dark"
              >
                How to use CashOver Merchant?
              </Link>
            </div>
          </div>
          <img
            alt="image"
            src="/merchant%20hero.webp"
            className="home-image19"
          />
        </div>
      </main>
      <main className="home-column24">
        <div className="home-container40">
          <div className="home-container41">
            <h3 className="home-text169">
              <span>
                Built for Scale — Ready for
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text171">Business</span>
              <span>.</span>
            </h3>
            <h3 className="home-text173">
              <span>
                Handle payrolls, in-store and online payments, and
                multi-platform operations with ease. CashOver is engineered for
                enterprises, logistics, and high-growth platforms.
              </span>
              <br></br>
            </h3>
            <div className="home-container42">
              <div className="home-container43">
                <div className="home-container44">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon42"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
                      <path
                        d="M18 2a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3h-3v-6a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3v6H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm-6 12a1 1 0 0 1 .993.883L13 15v6h-3v-6a1 1 0 0 1 .883-.993L11 14zm6-10H5a1 1 0 0 0-.993.883L4 5v1a2 2 0 0 0 3.94.49l.032-.155a1 1 0 0 1 .898-.831L9 5.5a1 1 0 0 1 .993.883L10 6.5a1.5 1.5 0 0 0 2.993.144L13 6.5a1 1 0 0 1 .883-.993l.135-.007a1 1 0 0 1 .984.723l.026.112a2 2 0 0 0 3.967-.186L19 6V5a1 1 0 0 0-.883-.993z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="home-container45">
                  <span className="home-text176">Real-Time Salary Payouts</span>
                  <span className="home-text177">
                    <span>
                      Send employee salaries or contractor payouts down to the
                      millisecond—directly from your CashOver merchant
                      dashboard.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container46">
                <div className="home-container47">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 1024 1024"
                    className="home-icon46"
                  >
                    <path
                      d="M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="home-container48">
                  <span className="home-text180">
                    <span>Accept Payments Anywhere</span>
                    <br></br>
                  </span>
                  <span className="home-text183">
                    <span>
                      Whether it’s in-store, online, or on-the-go, CashOver
                      gives you full control across mobile, tablet, or web.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container49">
                <div className="home-container50">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon48"
                  >
                    <path
                      d="M5 21q-.825 0-1.412-.587T3 19V6.5q0-.35.113-.663t.337-.587l1.4-1.7q.225-.275.513-.413T6 3h12q.35 0 .638.138t.512.412l1.4 1.7q.225.275.338.588T21 6.5V19q0 .825-.587 1.413T19 21zm.4-15h13.2l-.85-1H6.25zm9.15 11.05l3.55-3.55l-3.55-3.55l-1.45 1.45l2.1 2.1l-2.1 2.1zm-5.05 0l1.45-1.45l-2.1-2.1l2.1-2.1L9.5 9.95L5.95 13.5z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="home-container51">
                  <span className="home-text186">
                    <span>Lowest Fees, Maximum Flexibility</span>
                    <br></br>
                  </span>
                  <span className="home-text189">
                    <span>
                      Integrate payments into your site or app in minutes with
                      transparent, ultra-low fees. Scalable for projects of any
                      size.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
            <img alt="image"  src="/business%20bills.webp" className="home-image20" />
            <div className="home-container52">
              <a
                href="tel:+9616424108"
                id="Get started with cashover business"
                name="CashOver Merchant"
                className="home-link4 button"
              >
                Book a Free Demo
              </a>
              <Link
                to="/business"
                id="Get started with cashover business"
                name="CashOver Merhant"
                className="home-navlink3 thq-button-outline-dark"
              >
                Learn More
              </Link>
            </div>
          </div>
          <img
            alt="image"
            src="/business%20bills.webp"
            className="home-image21"
          />
        </div>
      </main>
      <main className="home-column25">
        <div className="home-row16">
          <div className="home-column26">
            <h1 className="home-title2">
              <span>
                Cash-In or Out —
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text193">Wherever</span>
              <span> You Are.</span>
            </h1>
            <h2 className="home-subtitle2">
              Use our agent or ATM network to deposit or withdraw. Perfect for
              unbanked or cash-preferred users.
            </h2>
            <div className="home-container53">
              <div className="home-container54">
                <div className="home-container55">
                  <span className="home-text195">01</span>
                </div>
                <div className="home-container56">
                  <span className="home-text196">Find a CashOver Point</span>
                  <span className="home-text197">
                    <span>Locate a CashOver ATM or Agent using the map.</span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container57">
                <div className="home-container58">
                  <span className="home-text200">02</span>
                </div>
                <div className="home-container59">
                  <span className="home-text201">
                    <span>Scan to Begin</span>
                    <br></br>
                  </span>
                  <span className="home-text204">
                    <span>
                      Scan the agent&apos;s or ATM’s QR code using your app.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container60">
                <div className="home-container61">
                  <span className="home-text207">03</span>
                </div>
                <div className="home-container62">
                  <span className="home-text208">Choose Amount</span>
                  <span className="home-text209">
                    <span>
                      Select whether to Deposit or Withdraw, and enter the
                      amount.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
              <div className="home-container63">
                <div className="home-container64">
                  <span className="home-text212">04</span>
                </div>
                <div className="home-container65">
                  <span className="home-text213">Complete &amp; Confirm</span>
                  <span className="home-text214">
                    <span>
                      Hand over or receive the cash — you&apos;re done!
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img alt="atm image" src="/atm.webp" className="home-atm-image" />
        </div>
      </main>
      <main className="home-column27">
        <div className="home-column28">
          <h2 className="home-text217">
            <span>
              Start Using
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <span className="home-text219">CashOver</span>
            <span> Today</span>
          </h2>
          <span className="home-text221">
            <span>
              From Personal use to big Businesses, CashOver covers all!
            </span>
            <br></br>
          </span>

          <div className="home-row17">
            <Link to="/signup" className="home-navlink4">
              <div className="home-column29">
                <main className="home-column30">
                  <div className="home-row18">
                    <svg width="35" height="35" viewBox="0 0 36 36">
                      <path
                        d="M12 16.14h-.87a8.67 8.67 0 0 0-6.43 2.52l-.24.28v8.28h4.08v-4.7l.55-.62l.25-.29a11 11 0 0 1 4.71-2.86A6.6 6.6 0 0 1 12 16.14"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-1"
                      ></path>
                      <path
                        d="M31.34 18.63a8.67 8.67 0 0 0-6.43-2.52a11 11 0 0 0-1.09.06a6.6 6.6 0 0 1-2 2.45a10.9 10.9 0 0 1 5 3l.25.28l.54.62v4.71h3.94v-8.32Z"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-2"
                      ></path>
                      <path
                        d="M11.1 14.19h.31a6.45 6.45 0 0 1 3.11-6.29a4.09 4.09 0 1 0-3.42 6.33Z"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-3"
                      ></path>
                      <path
                        d="M24.43 13.44a7 7 0 0 1 0 .69a4 4 0 0 0 .58.05h.19A4.09 4.09 0 1 0 21.47 8a6.53 6.53 0 0 1 2.96 5.44"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-4"
                      ></path>
                      <circle
                        r="4.47"
                        cx="17.87"
                        cy="13.45"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-5"
                      ></circle>
                      <path
                        d="M18.11 20.3A9.7 9.7 0 0 0 11 23l-.25.28v6.33a1.57 1.57 0 0 0 1.6 1.54h11.49a1.57 1.57 0 0 0 1.6-1.54V23.3l-.24-.3a9.58 9.58 0 0 0-7.09-2.7"
                        fill="currentColor"
                        className="clr-i-solid clr-i-solid-path-6"
                      ></path>
                      <path d="M0 0h36v36H0z" fill="none"></path>
                    </svg>
                    <h3 className="home-text224">Personal</h3>
                  </div>
                  <h4 className="home-text225">
                    Your personal account for all your personal needs
                  </h4>
                  <p className="home-text226">
                    With CashOver, handle daily tasks and shopping effortlessly.
                    Manage your finances, send and receive money seamlessly, and
                    exchange USDT for cash hassle-free.
                  </p>
                </main>
                <svg viewBox="0 0 1024 1024" className="home-icon58">
                  <path d="M567.168 311.168c-16.683 16.683-16.683 43.648 0 60.331l97.835 97.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h323.669l-97.835 97.835c-16.683 16.683-16.683 43.648 0 60.331 8.32 8.32 19.243 12.501 30.165 12.501s21.845-4.181 30.165-12.501l200.832-200.832-200.832-200.832c-16.683-16.683-43.648-16.683-60.331 0z"></path>
                </svg>
              </div>
            </Link>
            <Link to="/merchant" className="home-navlink4">
              <div className="home-column31">
                <div className="home-column32">
                  <div className="home-row19">
                    <svg viewBox="0 0 1024 1024" className="home-icon60">
                      <path d="M224 0c-106.040 0-192 100.288-192 224 0 105.924 63.022 194.666 147.706 217.998l-31.788 518.124c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.788-518.124c84.684-23.332 147.706-112.074 147.706-217.998 0-123.712-85.96-224-192-224zM869.334 0l-53.334 320h-40l-26.666-320h-26.668l-26.666 320h-40l-53.334-320h-26.666v416c0 17.672 14.326 32 32 32h83.338l-31.42 512.122c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.42-512.122h83.338c17.674 0 32-14.328 32-32v-416h-26.666z"></path>
                    </svg>
                    <h3 className="home-text227">Merchant</h3>
                  </div>
                  <h4 className="home-text228">
                    scan, pay, receive. super fast!
                  </h4>
                  <p className="home-text229">
                    Accept payments, assign employees, track orders, analyze
                    income sources, and secure your money. Benefit from a free
                    product list/menu of whatever you sell.
                  </p>
                </div>
                <svg viewBox="0 0 1024 1024" className="home-icon62">
                  <path d="M567.168 311.168c-16.683 16.683-16.683 43.648 0 60.331l97.835 97.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h323.669l-97.835 97.835c-16.683 16.683-16.683 43.648 0 60.331 8.32 8.32 19.243 12.501 30.165 12.501s21.845-4.181 30.165-12.501l200.832-200.832-200.832-200.832c-16.683-16.683-43.648-16.683-60.331 0z"></path>
                </svg>
              </div>
            </Link>
            <Link to="/business" className="home-navlink5">
              <div className="home-column33">
                <div className="home-column34">
                  <div className="home-row20">
                    <svg viewBox="0 0 1024 1024" className="home-icon64">
                      <path d="M768 640v86h-86v-86h86zM768 470v84h-86v-84h86zM854 810v-426h-342v86h86v84h-86v86h86v86h-86v84h342zM426 298v-84h-84v84h84zM426 470v-86h-84v86h84zM426 640v-86h-84v86h84zM426 810v-84h-84v84h84zM256 298v-84h-86v84h86zM256 470v-86h-86v86h86zM256 640v-86h-86v86h86zM256 810v-84h-86v84h86zM512 298h426v598h-852v-768h426v170z"></path>
                    </svg>
                    <h3 className="home-text230">Business</h3>
                  </div>
                  <h4 className="home-text231">
                    Enterprise Finance Management
                  </h4>
                  <p className="home-text232">
                    Invoice salaries, track expenses and manage your taxes.
                    Ultra low fees, fast and secure invoicing system for up to
                    5000 employees.
                  </p>
                </div>
                <svg viewBox="0 0 1024 1024" className="home-icon66">
                  <path d="M567.168 311.168c-16.683 16.683-16.683 43.648 0 60.331l97.835 97.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h323.669l-97.835 97.835c-16.683 16.683-16.683 43.648 0 60.331 8.32 8.32 19.243 12.501 30.165 12.501s21.845-4.181 30.165-12.501l200.832-200.832-200.832-200.832c-16.683-16.683-43.648-16.683-60.331 0z"></path>
                </svg>
              </div>
            </Link>
          </div>
          <div className="home-row21">
            <a href="#contactForm" className="home-link5">
              <div className="home-column35">
                <main className="home-column36">
                  <div className="home-row22">
                    <svg viewBox="0 0 1024 1024" className="home-icon68">
                      <path d="M384 682.667c0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667c0-23.564 19.103-42.667 42.667-42.667 23.564 0 42.667 19.103 42.667 42.667z"></path>
                      <path d="M884.608 198.699c-16.725-16.128-43.221-16.085-59.691 0.384 16.512-16.469 16.555-43.008 0.427-59.733-45.995-33.792-102.613-54.016-164.011-54.016-153.173 0-277.333 124.16-277.333 277.333 0 5.504 0.981 10.752 1.323 16.171-14.379 10.197-123.435 91.605-181.675 140.843-48.427 42.24-75.648 101.333-75.648 162.987 0 117.632 95.701 213.333 213.333 213.333 62.507 0 121.771-27.733 162.603-76.117 50.048-58.667 131.413-167.381 141.525-180.437 5.12-0.427 10.368 0.555 15.872 0.555 153.173 0 277.333-124.16 277.333-277.333 0-61.44-20.224-118.016-54.059-163.968zM341.333 810.667c-70.656 0-128-57.301-128-128 0-39.253 18.048-73.899 45.397-97.792 101.035-85.419 154.325-117.248 218.24-171.307-4.48-16.299-7.637-33.152-7.637-50.901 0-106.027 85.973-192 192-192 20.053 0 38.997 3.925 57.131 9.643l-121.131 118.357 21.333 106.667 106.667 21.333 119.68-116.949c4.907 16.896 8.32 34.432 8.32 52.949 0 106.027-85.973 192-192 192-17.749 0-34.603-3.157-50.901-7.68-54.059 63.915-85.888 117.248-171.691 217.813-23.509 27.819-58.155 45.867-97.408 45.867zM827.051 267.563l-115.413 112.853-56.704-11.349-11.221-56.064 116.309-113.621c27.776 16.768 50.773 40.064 67.029 68.181z"></path>
                    </svg>
                    <h3 className="home-text233">Custom Finance Solutions</h3>
                  </div>
                  <h4 className="home-text234">
                    create your own finance system
                  </h4>
                  <p className="home-text235">
                    Our team will analyze your financial needs and tailor-make a
                    complete solution just for you. Consult with CashOver team
                    in order to fill the gaps with your business and take it to
                    the next level.
                  </p>
                </main>
                <svg viewBox="0 0 1024 1024" className="home-icon71">
                  <path d="M567.168 311.168c-16.683 16.683-16.683 43.648 0 60.331l97.835 97.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h323.669l-97.835 97.835c-16.683 16.683-16.683 43.648 0 60.331 8.32 8.32 19.243 12.501 30.165 12.501s21.845-4.181 30.165-12.501l200.832-200.832-200.832-200.832c-16.683-16.683-43.648-16.683-60.331 0z"></path>
                </svg>
              </div>
            </a>
            <Link to="/cash-over-sdk" className="home-navlink6">
              <div className="home-column37">
                <div className="home-column38">
                  <div className="home-row23">
                    <svg
                      viewBox="0 0 1243.4285714285713 1024"
                      className="home-icon73"
                    >
                      <path d="M365.714 932.571l219.429-109.714v-179.429l-219.429 93.714v195.429zM329.143 673.143l230.857-98.857-230.857-98.857-230.857 98.857zM950.857 932.571l219.429-109.714v-179.429l-219.429 93.714v195.429zM914.286 673.143l230.857-98.857-230.857-98.857-230.857 98.857zM658.286 505.714l219.429-94.286v-152l-219.429 93.714v152.571zM621.714 289.143l252-108-252-108-252 108zM1243.429 585.143v237.714c0 27.429-15.429 53.143-40.571 65.143l-256 128c-10.286 5.714-21.143 8-32.571 8s-22.286-2.286-32.571-8l-256-128c-1.714-0.571-2.857-1.143-4-2.286-1.143 1.143-2.286 1.714-4 2.286l-256 128c-10.286 5.714-21.143 8-32.571 8s-22.286-2.286-32.571-8l-256-128c-25.143-12-40.571-37.714-40.571-65.143v-237.714c0-29.143 17.714-55.429 44.571-67.429l248-106.286v-228.571c0-29.143 17.714-55.429 44.571-67.429l256-109.714c9.143-4 18.857-5.714 28.571-5.714s19.429 1.714 28.571 5.714l256 109.714c26.857 12 44.571 38.286 44.571 67.429v228.571l248 106.286c27.429 12 44.571 38.286 44.571 67.429z"></path>
                    </svg>
                    <h3 className="home-text236">CashOver SDK</h3>
                  </div>
                  <h4 className="home-text237">
                    Add CashOver To your platform
                  </h4>
                  <p className="home-text238">
                    Accept payments, perform checkouts and analyze income
                    patterns. Implement CashOver SDK on your website or mobile
                    app in order to profit from your business and increase your
                    portfolio. Hassle-free simple code with clear documentation.
                  </p>
                </div>
                <svg viewBox="0 0 1024 1024" className="home-icon75">
                  <path d="M567.168 311.168c-16.683 16.683-16.683 43.648 0 60.331l97.835 97.835h-323.669c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h323.669l-97.835 97.835c-16.683 16.683-16.683 43.648 0 60.331 8.32 8.32 19.243 12.501 30.165 12.501s21.845-4.181 30.165-12.501l200.832-200.832-200.832-200.832c-16.683-16.683-43.648-16.683-60.331 0z"></path>
                </svg>
              </div>
            </Link>
          </div>
          <h1 className="home-text239">What are you waiting for?</h1>
          <h2 className="home-text240">
            Transform the way you handle your finances
          </h2>
          <div className="home-row24">
            <img alt="image" src="/icon.webp" className="home-image22" />
          </div>
        </div>
      </main>
      <FAQPersonal rootClassName="faq-personalroot-class-name"></FAQPersonal>
      <ContactFormLight rootClassName="contact-form-lightroot-class-name"></ContactFormLight>
      <Footer></Footer>
    </div>
  );
};

export default Home;
